module.exports = __webpack_public_path__ + "img/icon-illustration-coupon-item.8bcb3deb.svg";